import styled from 'styled-components';
import { Typography } from 'components/generic/typography';

const LineThrough = styled(Typography.Body)`
    text-decoration: line-through;
`;

export default LineThrough;
